export default function ({ $gtm }) {
    $gtm.init(process.env.GOOGLE_TAG_MANAGER_ID)
}